<template>
  <v-layout justify-start column class="mb-4" style="background-color:#eae8e6;">
    <case-header-new :initialState="initialState"></case-header-new>
    <Loading :isLoading="isLoading">
    <v-container v-if="currentSchema" fluid pa-3 ma-0>
      <v-layout row wrap mb-4>
        <v-flex sm12 md9 px-0 class="no-jump-to-column">
          <fieldset-container
            v-if="!isLoading"
            id="case-data-all"
            :caseData="currentCase"
            :caseType="caseType"
            :caseIsLoading="isLoading"
            :hasPermissionToSave="hasPermissionToSave"            
            v-on:fieldset-list-updated="fieldsetListUpdated"
            v-on:save="save()"
            new-case>
          </fieldset-container>
        </v-flex>
        <v-flex md3 px-2 mb-0 style="position: relative;" class="no-jump-to-column hidden-sm-and-down" v-if="showJumpToMenu">
          <v-flex xs12 px-0 class="rounded-3">
            <div class="caption opacity-54 mb-1 text-uppercase primary--text"><PageTitle pageTitle="Jump to a section"></PageTitle></div>
            <v-divider class="mb-0"></v-divider>
          </v-flex>
          <case-menu
            id="case-edit-menu"
            v-if="!isLoading"
            :headers="orderedHeaders"
            :buttonText="'Create new ' + caseTypeName"
            :buttonEnabled="isValid"
            :caseIsLoading="isLoading"
            :hasPermissionToSave="hasPermissionToSave"            
            v-on:save="save()"
            v-on:cancel="cancel()">
          </case-menu>
        </v-flex>
      </v-layout>
      <v-layout align-baseline xs12 md4 px-2 right>
          <v-snackbar v-model="showTaskResult" :bottom="true" :right="true">
            {{ taskResult.message }}
            <v-btn
              :color="((taskResult.error) ? 'error' : 'success')"
              flat
              @click="showTaskResult = false">
              Close
            </v-btn>
          </v-snackbar>
      </v-layout>
    </v-container>
    <v-container v-if="!currentSchema">
      <p> Warning, {{ caseTypeName }} does not have a schema. Please create and configure the template before use. </p>
    </v-container>
    </Loading>
  </v-layout>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue"
import FieldsetContainer from "@/components/cases/case-edit/FieldsetContainer.vue"
import Helpers from "@/helpers.js"
import CaseMenu from '@/components/cases/case-edit/CaseMenu'
import Loading from '@/components/shared/Loading.vue'
import { mapState } from 'vuex'
import CaseHeaderNew from "@/components/cases/case-edit/CaseHeaderNew.vue"

export default {
  name: "CaseNew",
  data: () => ({
    isValid: false,
    showTaskResult: false,
    orderedHeaders: []
  }),
  components: { Loading, PageTitle, FieldsetContainer, CaseMenu, CaseHeaderNew },
  props: {
    helpers: {
      type: Object,
      default: function() { return Helpers }
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.buckets.current.loading,
      caseType: state => state.buckets.current.caseType,
      currentCase: state => state.cases.currentlySelected.case,
      permissions: state => state.ui.grantedPermissions,
      caseTypeCode: state =>
        state &&
        state.buckets &&
        state.buckets.current.caseType &&
        state.buckets.current.caseType.code
          ? state.buckets.current.caseType.code
          : undefined,      
      currentUser: state => state.currentUser,
      taskResult: state => state.cases.taskResult,
      allUsers: state => state.users.all,
      allTeams: state => state.teams.all,
      showJumpToMenu: state => state.ui.keepMainMenuExpanded
    }),
    initialState() {
      if (!this.isLoading && this.caseType && this.caseType.statuses && this.caseType.statuses[0]) { return this.caseType.statuses[0].state } else { return "Not Started" }
    },
    caseTypeId() { return parseInt(this.$route.params.case_type_id) },
    caseTypeName() { if (!this.isloading && this.currentCase) { return this.currentCase.caseType } else { return "Case" } },
    pageTitle() { if (!this.isloading && this.currentCase) { return "New " + this.caseTypeName } else { return "New Case" } },
    currentSchema() {
      if (!this.isloading && this.currentCase) {
        return this.currentCase.schema
      } else {
        return undefined
      }
    },
    hasPermissionToSave() {
      if (this.currentUser.isAccountAdmin) { return true }
      return Helpers.hasPermission(this.permissions, "Create", this.caseTypeCode)
    },    
  },
  watch: {
    taskResult() {
      this.showTaskResult = (this.taskResult !== undefined)
      setTimeout(() => {
        this.showTaskResult = false
        if (!this.taskResult.error) { this.$router.back() }
      }, 6000)
    }
  },
  methods: {
    fieldsetListUpdated({ fieldsetList }) {
      const headers = []
      const rows = fieldsetList || []
      for (const row of rows) {
        for (const fs of row) {
          headers.push(fs.display_name || fs.name)
        }
      }
      this.orderedHeaders = headers
    },
    async save() {
      const title = this.currentCase.properties.title
      const caseTypeCode = this.caseType.code

      const properties = Object.assign({}, this.currentCase.properties)
      properties.case_type_id = this.caseType.id

      const currentState = properties.current_state ? properties.current_state : this.initialState
      await this.$store.dispatch("createCase", { title, currentState, caseTypeCode, properties })
      this.showTaskResult = true
    },
    cancel() {
      this.$router.back()
    }
  }
}
</script>
